// User
export const USER_LOGIN = 'USER_LOGIN';
export const USER_AUTHENTICATE = 'USER_AUTHENTICATE';
export const USER_REGISTER = 'USER_REGISTER';
export const USER_UPDATE = 'USER_UPDATE';
export const STUDENT_LOGOUT = 'STUDENT_LOGOUT';
export const STUDENT_LOGIN = 'STUDENT_LOGIN';
export const STUDENT_AUTHENTICATE = 'STUDENT_AUTHENTICATE';

// Story
export const STORY_ADD = 'STORY_ADD';
export const STORY_DELETE = 'STORY_DELETE';
export const SET_STORIES = 'SET_STORIES';
export const STORY_MARK_IMPORTANT = 'STORY_MARK_IMPORTANT';
export const STORY_MARK_GRADED = 'STORY_MARK_GRADED';

export const SET_SELECTED_STORY = 'SET_SELECTED_STORY';

// Groups
export const SET_GROUPS = 'SET_GROUPS';
export const ADD_GROUP = 'ADD_GROUP';
export const DELETE_GROUP = 'DELETE_GROUP';

export const UPDATE_PERMISSIONS = 'UPDATE_PERMISSIONS';

// Group
export const ADD_STUDENT = 'ADD_STUDENT';
export const DELETE_STUDENT = 'DELETE_STUDENT';
export const UPDATE_STUDENT = 'UPDATE_STUDENT';
export const GENERATE_USERNAME = 'GENERATE_USERNAME';
export const GENERATE_USERNAME_ALL = 'GENERATE_USERNAME_ALL';
export const SEND_USERNAME = 'SEND_USERNAME'; 
export const SEND_USERNAME_ALL = 'SEND_USERNAME_ALL';
export const ADD_CAMPAIGN = 'ADD_CAMPAIGN';
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN';
export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN';


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/constants/actions.ts